var _linearGradient, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaterialdesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "656.911 227.618 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-0-0",
    gradientUnits: "userSpaceOnUse",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    xlinkHref: "#gradient-0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0, 235, 170)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(94, 103, 223)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-1",
    x1: 12,
    x2: 12,
    y1: 3.6,
    y2: 20.4,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(94, 103, 223)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0, 235, 170)"
    }
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(1, 0, 0, 1, 656.911377, 227.618408)",
    style: {
      fill: "url(#gradient-0-0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.6 3.6h16.8v16.8h-16.8z",
    transform: "matrix(1, 0, 0, 1, 656.911377, 227.618408)",
    style: {
      paintOrder: "fill",
      fillRule: "nonzero",
      fill: "url(#gradient-1)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.4 3.6-8.4 16.8-8.4-16.8z",
    transform: "matrix(1, 0, 0, 1, 656.911377, 227.618408)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    transform: "matrix(1, 0, 0, 1, 656.911377, 227.618408)",
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialdesign);
export default __webpack_public_path__ + "static/media/materialdesign.c37e194349e955621b9c2d4be18eadcf.svg";
export { ForwardRef as ReactComponent };